'use strict';

angular.module('itPurchasingControllers')

.controller('ItPurchasingActionsController', ['$scope', 'growl', 'ITPurchasingService', '$translate', function ($scope, growl, ITPurchasingService, $translate) {

    $scope.saveProcess = null;

    $scope.authorizeCard = function () {
        $scope.authorizeCardInProgress = true;
        ITPurchasingService.authorizeSignificantCost($scope.selectedCard)
                           .then(function (newContainer) {
                               $scope.authorizeCardInProgress = false;
                               var newCard = newContainer.SystemsAndEmployees[0];
                               for (var attrname in newCard) {
                                   $scope.selectedCard[attrname] = newCard[attrname];
                               }
                           });
    };

    $scope.saveCard = function () {
        $scope.saveProcess = $translate.instant('iam.itPurchasing.actions.saving.label');

        ITPurchasingService.saveSignificantCost($scope.selectedCard)
                           .then(function () {
                               var message = '<span class="gritter-title">' + $translate.instant('iam.itPurchasing.messages.instructionsSaved') + '</span>';
                               growl.addSuccessMessage(message, { enableHtml: true, ttl: 1 });
                               $scope.saveProcess = null;
                           });
    };
}]);